<div class="layout">
  <!-- Loading bar -->
  <fuse-loading-bar></fuse-loading-bar>

  <!-- Navigation -->
  <fuse-vertical-navigation
    class="dark bg-gradient-to-t from-primary-900 to-primary-700 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="menuItems"
    [opened]="!isScreenSmall"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center justify-center">
        <img class="w-8" src="assets/images/logo/Logo-Gray.svg" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>

  <!-- Wrapper -->
  <div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div class="app-sticky-top bg-card sticky top-0 z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
      <!-- Left side -->
      <div class="flex items-center gap-2">
        <!-- Navigation toggle (mobile) -->
        @if (isScreenSmall) {
          <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
          </button>
        }
        <!-- Navigation appearance toggle (desktop) -->
        <button class="hidden md:inline-flex" mat-icon-button (click)="toggleNavigationAppearance()" matTooltip="Toggle sidebar">
          <mat-icon [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>
        </button>
        <!-- Company logo + name -->
        @if (!isScreenSmall) {
          <div class="ms-2 flex items-center gap-3">
            @if (_authService.profile()?.company?.logo_url) {
              <img [src]="_authService.profile()?.company?.logo_url" class="h-12 max-h-12 w-auto max-w-[180px] object-contain" alt="Company logo" />
            }
            <span class="hidden whitespace-nowrap text-base font-semibold uppercase tracking-wide text-gray-700 lg:block">
              {{ _authService.profile()?.company?.company_name }}
            </span>
          </div>
        }
      </div>

      <div class="ml-auto flex items-center gap-4">
        <div class="hidden items-center gap-4 lg:flex">
          <a href="https://apps.apple.com/ae/app/iskaan-cm/id1578876772" target="_blank">
            <img src="assets/img/Appstore.svg" title="Download the iOS App Now!" class="h-6 w-6" alt="ios-download" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.iskaan.iskaan" target="_blank">
            <img src="assets/img/Playstore.svg" title="Download the Android App Now!" class="h-6 w-6" alt="android-download" />
          </a>
        </div>
        <!-- Dashboard view toggle -->
        @if (isDashboardRoute && dashboardSvc.showViewToggle()) {
          <button mat-icon-button [matMenuTriggerFor]="dashboardViewMenu" matTooltip="Dashboard View" class="header-icon-btn">
            <mat-icon class="icon-size-7" fontIcon="grid_view"></mat-icon>
          </button>
          <mat-menu #dashboardViewMenu="matMenu" class="dashboard-view-panel">
            <div class="px-4 pb-2 pt-3" (click)="$event.stopPropagation()">
              <div class="text-secondary mb-3 text-xs font-semibold uppercase tracking-widest">Dashboard View</div>
              <div class="grid grid-cols-2 gap-2">
                <!-- Personal -->
                <button
                  class="flex flex-col items-center rounded-lg border-2 p-3 transition-colors"
                  [ngClass]="dashboardSvc.dashboardView() === 'detail' ? 'border-primary text-primary' : 'border-gray-200 text-gray-400 hover:border-gray-300'"
                  (click)="selectDashboardView('detail')"
                >
                  <mat-icon class="mb-1 !text-4xl" fontIcon="speed"></mat-icon>
                  <span class="text-xs font-semibold uppercase tracking-wide">Personal</span>
                </button>
                <!-- Map -->
                @if (_authService.canAccess(['dashboard_mapview'])) {
                  <button
                    class="flex flex-col items-center rounded-lg border-2 p-3 transition-colors"
                    [ngClass]="dashboardSvc.dashboardView() === 'map' ? 'border-primary text-primary' : 'border-gray-200 text-gray-400 hover:border-gray-300'"
                    (click)="selectDashboardView('map')"
                  >
                    <mat-icon class="mb-1 !text-4xl" fontIcon="map"></mat-icon>
                    <span class="text-xs font-semibold uppercase tracking-wide">Map</span>
                  </button>
                }
              </div>
            </div>
          </mat-menu>
        }
        <!-- Notifications -->
        <app-notifications></app-notifications>
        <!-- User -->
        <user></user>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
      <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <div class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden">
      <span class="text-secondary font-medium">ISKAAN &copy; {{ currentYear }}</span>
    </div>
  </div>
</div>
